import React from 'react'

const MissionPage = () => {
   return (
    <div className="about-section">
      <span className="about-label">Mission</span>
      <div className="about-gold-bar" />
      <p className="about-body">
        To architect and execute AI-led, digital transformation programs that
        scale, adapt, and deliver sustained business impact.
      </p>
    </div>
  );
}

export default MissionPage